export const VIEWER_FILE = "viewer_file";
export const VIEWER_CLEAN = "viewer_clean";
export const VIEWER_LOAD = "viewer_load";
